import { ApprovalsFiltersName } from "@/pages/inbox/types";
import { ButtonSize, ButtonVariant } from "@/components";
import { Cancel, Edit, StatusAvailable as Submit } from "@/assets/icons";
import styles from "@/pages/inbox/components/inbox-details/styles.scss";
import { ActionsProps } from "@/pages/inbox/components/inbox-details/types";

const enum RequestActionsName {
  Cancel = "Cancel",
  Edit = "Edit",
  Submit = "Submit",
}

export const requestActionsMap = {
  [ApprovalsFiltersName.Draft]: [
    RequestActionsName.Cancel,
    RequestActionsName.Edit,
  ],
  [ApprovalsFiltersName.Returned]: [
    RequestActionsName.Cancel,
    RequestActionsName.Edit,
  ],
  [ApprovalsFiltersName.Revised]: [
    RequestActionsName.Cancel,
    RequestActionsName.Edit,
  ],
  [ApprovalsFiltersName.InProgress]: [RequestActionsName.Cancel],
  [ApprovalsFiltersName.Completed]: [],
  [ApprovalsFiltersName.Cancelled]: [],
};

export const requestActionsMapProps = {
  [RequestActionsName.Cancel]: ({
    isLocked,
    handleCancelRequest,
  }: ActionsProps) => ({
    disabled: isLocked,
    variant: ButtonVariant.Negative,
    size: ButtonSize.Small,
    icon: <Cancel className={styles.actionButtonIcon} />,
    onClick: handleCancelRequest,
  }),
  [RequestActionsName.Edit]: ({ isLocked, handleEdit }: ActionsProps) => ({
    disabled: isLocked,
    variant: ButtonVariant.Secondary,
    size: ButtonSize.Small,
    icon: <Edit className={styles.actionButtonIcon} />,
    onClick: handleEdit,
  }),
  [RequestActionsName.Submit]: ({
    isLocked,
    handleSubmitRequest,
  }: ActionsProps) => ({
    disabled: isLocked,
    variant: ButtonVariant.Positive,
    size: ButtonSize.Small,
    icon: <Submit className={styles.actionButtonIcon} />,
    onClick: handleSubmitRequest,
  }),
};
